// extracted by mini-css-extract-plugin
export var alert = "Dialog-module--alert--UKW5I";
export var box = "Dialog-module--box--tw3Qb";
export var component = "Dialog-module--component--0eLQk";
export var description = "Dialog-module--description--YeSzc";
export var headline = "Dialog-module--headline--DiuQb";
export var list = "Dialog-module--list--0tFWb";
export var logo = "Dialog-module--logo--mzaUU";
export var nav = "Dialog-module--nav--k5gp7";
export var wrapper = "Dialog-module--wrapper--znMqW";